import styled from 'styled-components'

export const MarketContainer = styled.div`
  padding: 20px;
  overflow-y: auto;
`

export const MarketOverview = styled.div`
  border-radius: 8px;
  margin-bottom: 24px;
`

export const MarketHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`

export const MarketTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
`

export const PostalCode = styled.span`
  font-size: 13px;
  color: #6b6b6b;
  font-weight: 400;
`

export const MarketStats = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
`

export const MarketStat = styled.div`
  background: #ffffff;
  border-radius: 6px;
  padding: 10px;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
`

export const StatLabel = styled.div`
  font-size: 11px;
  color: #6b6b6b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
`

export const StatValue = styled.div<{ $smaller?: boolean }>`
  font-size: ${(props) => (props.$smaller ? '18px' : '20px')};
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 4px;
`

export const StatChange = styled.div<{ $positive?: boolean }>`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 500;
  color: ${(props) => (props.$positive ? '#00b341' : '#ff3b30')};
`

export const ChangeIcon = styled.div`
  width: 12px;
  height: 12px;
  display: flex;

  svg {
    width: 100%;
    height: 100%;
  }
`

export const PriceHistory = styled.div`
  margin-bottom: 24px;
`

export const SectionHeader = styled.div<{ $withControls?: boolean }>`
  margin-bottom: 16px;
  ${(props) =>
    props.$withControls &&
    `
    display: flex;
    flex-direction: column;
    gap: 12px;
  `};
`

export const MarketSectionTitle = styled.h4`
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
`

export const ChartControls = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`

export const PropertyTypeSelector = styled.div`
  display: flex;
  gap: 4px;
  background: #fafafa;
  padding: 2px;
  border-radius: 6px;
  margin-right: auto;
`

export const TypeButton = styled.button<{ $active?: boolean }>`
  padding: 4px 12px;
  border: none;
  background: ${(props) => (props.$active ? '#ffffff' : 'none')};
  color: ${(props) => (props.$active ? '#00ade6' : '#6b6b6b')};
  font-size: 11px;
  font-weight: 500;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  font-family: inherit;

  ${(props) =>
    props.$active &&
    `
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  `}

  &:hover {
    color: ${(props) => (props.$active ? '#00ade6' : '#1a1a1a')};
  }
`

export const TimeSelector = styled.div`
  display: flex;
  gap: 4px;
`

export const TimeButton = styled.button<{ $active?: boolean }>`
  padding: 4px 8px;
  border: none;
  background: ${(props) => (props.$active ? '#e6f7fc' : 'none')};
  color: ${(props) => (props.$active ? '#00ade6' : '#6b6b6b')};
  font-size: 11px;
  font-weight: 500;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  font-family: inherit;

  &:hover {
    background: ${(props) => (props.$active ? '#e6f7fc' : '#fafafa')};
  }
`

export const ChartContainer = styled.div`
  height: 180px;
  background: #fafafa;
  border-radius: 8px;
  padding: 12px;
  position: relative;
`

export const Chart = styled.div`
  width: 100%;
  height: 100%;
`

export const MarketComparison = styled.div`
  margin-bottom: 24px;
`

export const ComparisonGrid = styled.div`
  display: grid;
  gap: 10px;
`

export const ComparisonItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 10px;
  background: #fafafa;
  border-radius: 6px;
  transition: all 0.2s;

  &:hover {
    background: #f5f5f5;
  }
`

export const ComparisonIcon = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border-radius: 6px;
  flex-shrink: 0;

  svg {
    width: 18px;
    height: 18px;
    color: #00ade6;
  }
`

export const ComparisonLabel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  flex: 1;
`

export const ComparisonTitle = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: #1a1a1a;
  line-height: 1.2;
`

export const ComparisonSubtitle = styled.span`
  font-size: 10px;
  color: #6b6b6b;
  line-height: 1.2;
`

export const ComparisonValue = styled.div`
  text-align: right;
  flex-shrink: 0;
`

export const ComparisonPrice = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.2;
`

export const ComparisonDiff = styled.div`
  font-size: 10px;
  color: #6b6b6b;
  line-height: 1.2;
`

export const transactions = styled.div`
  margin-bottom: 24px;
`

export const TransactionList = styled.div`
  display: grid;
  gap: 8px;
`

export const TransactionItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  background: #fafafa;
  border-radius: 6px;
  font-size: 12px;
  transition: all 0.2s;
  cursor: pointer;

  &:hover {
    background: #f5f5f5;
    transform: translateX(4px);
  }
`

export const TransactionInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
`

export const PropertyImage = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 6px;
  object-fit: cover;
  flex-shrink: 0;
`

export const PropertyImagePlaceholder = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 6px;
  background: #e5e5e5;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 24px;
    height: 24px;
    color: #999999;
  }
`

export const TransactionDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
`

export const TransactionAddress = styled.span`
  font-weight: 500;
  color: #1a1a1a;
  font-size: 13px;
`

export const TransactionMeta = styled.div`
  font-size: 11px;
  color: #6b6b6b;
  display: flex;
  align-items: center;
  gap: 4px;
`

export const PropertyBadge = styled.span<{ $type: 'sale' | 'rent' }>`
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 500;
  margin-right: 4px;

  ${(props) =>
    props.$type === 'sale'
      ? `
    background: rgba(0, 179, 65, 0.1);
    color: #00b341;
  `
      : `
    background: rgba(255, 149, 0, 0.1);
    color: #ff9500;
  `}
`

export const TransactionPrice = styled.div`
  font-weight: 600;
  color: #1a1a1a;
`

export const ViewMore = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 6px;
  color: #00ade6;
  font-size: 12px;
  font-weight: 500;
  text-decoration: none;
  border-radius: 6px;
  transition: all 0.2s;

  &:hover {
    background: #e6f7fc;
  }
`

export const AnalyticsLink = styled(ViewMore)`
  margin-top: 12px;
`

export const ArrowIcon = styled.div`
  width: 12px;
  height: 12px;
  transition: transform 0.2s;

  svg {
    width: 100%;
    height: 100%;
  }

  ${ViewMore}:hover & {
    transform: translateX(2px);
  }
`

export const EmptyState = styled.div`
  text-align: center;
  padding: 48px 24px;
`

export const EmptyIcon = styled.div`
  width: 48px;
  height: 48px;
  margin: 0 auto 16px;
  color: #999999;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 48px;
    height: 48px;
  }
`

export const EmptyTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #6b6b6b;
  margin-bottom: 8px;
`

export const EmptyDescription = styled.div`
  font-size: 13px;
  color: #999999;
`
